export default {
sets: `Settene`,
stats: `Statistikk`,
discover: `Oppdage`,
guides: `Guider`,
settings: `Innstillinger`,
unsupportedBrowserBody: `Flashcards støtter ikke denne nettleseren. Last ned den nyeste versjonen av Chrome eller Opera, eller last ned vår iPhone, eller Android -applikasjon`,
unsupportedBrowserTitle: `Ustøttet nettleser`,
noData: `Ingen data å vise`,
contactUsTitle: `Vi elsker å høre hvordan brukerne våre bruker appen vår, og hvordan vi kan forbedre oss. Send oss ​​en melding med alle spørsmål, for eksempel funksjonsforespørsler, eller feilrapporter`,
rateAppStore: `Priser i Appstore`,
rateGoogle: `Ranger i Google Play`,
close: `Lukk`,
shareFriends: `Del med venner`,
noCardsQ: `Har du ikke noen flashcards?`,
noCardsS: `Velg fra samlingen vår for å komme i gang`,
suggestSet: `Foreslå sett`,
createOwn: `Lag din egen`,
search: `Søk`,
loading: `Lasting`,
words: `Ord`,
downloads: `Nedlastinger`,
export: `Eksport`,
import: `Import`,
importing: `Importer ... ikke lukk appen`,
importPreview: `Importer forhåndsvisning`,
howQuizlet: `Hvordan importere fra Quizlet`,
cards: `Kort`,
importPreviewStatus: `__ vilkårene er klare til å bli lagt til de eksisterende ___ kortene`,
importPaste: `Lim inn kortene dine i den ovennevnte tekstområdet`,
setTotalLimitReached: `Du kan bare ha 3000 kort i et studysett`,
studying: `Studerer`,
learnt: `Lært`,
mastered: `Mestret`,
new: `Ny`,
noTerm: `Ingen begrep`,
noDef: `Ingen definisjon`,
cardSaved: `Kort lagret`,
reviews: `Anmeldelser`,
practices: `Praksis`,
flashcards: `Flashcards`,
alerts: `Varsler`,
corrects: `Korrigerer`,
mistakes: `Feil`,
reviewCycle: `Gjennomgangssyklus`,
reviewsLeft: `Anmeldelser igjen`,
lastReview: `Siste anmeldelse`,
nextReview: `Neste anmeldelse`,
hideHistory: `Skjul full historie`,
showHistory: `Vis full historie`,
strength: `Styrke`,
star: `Stjerne`,
image: `Bilde`,
tag: `stikkord`,
added: `la til`,
removed: `fjernet`,
reviewedFrom: `Gjennomgått fra __`,
notifications: `Varsler`,
reviewedPractice: `Gjennomgått __ av ___ praksis`,
successfully: `vellykket`,
unsuccessfully: `uten hell`,
termUpdated: `Begrep oppdatert`,
defUpdated: `Definisjon oppdatert`,
flashcardCreated: `Flashcard opprettet`,
dropboxImage: `Du må aktivere Dropbox -synkronisering for å legge til bilder`,
deleteImgConfirm: `Er du sikker på at du vil slette dette bildet?`,
uploading: `Last opp`,
save: `Lagre`,
uploadImageFail: `Kunne ikke laste opp bilde`,
imageUploaded: `Bilde lastet opp`,
setNotFound: `Studyset ikke funnet!`,
notEnoughCards: `Ikke nok kort!`,
of: `__ av ___`,
on: `På`,
off: `Av`,
auto: `Automatisk`,
manual: `Håndbok`,
pronounce: `Uttale`,
practiceCompleted: `Du har fullført denne praksisen`,
closePractice: `Nær praksis`,
autoplay: `Auto spill`,
secFlipSecNext: `__ Sec flip, ___ sek neste`,
autopronounce: `Autopronounce`,
onlyTerm: `Eneste termin`,
onlyDef: `Bare definisjon`,
termAndDef: `Begrep og definisjon`,
savePractice: `Spar praksis?`,
continueLater: `Fortsett senere`,
deletePractice: `Slett praksis`,
term: `Begrep`,
def: `Definisjon`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Gjennomgå mål`,
dailyGoal: `Daglig mål`,
edit: `Redigere`,
setUp: `Sett opp`,
noRecentPractice: `Du har ingen nyere praksis`,
continueLastReview: `Fortsett siste anmeldelse`,
dueCards: `Forfalte kort`,
studyNow: `Studer nå`,
newCards: `Nye kort`,
terms: `Vilkår`,
defs: `Definisjoner`,
validCardsOf: `Bare __ av de valgte ___ kortene kan praktiseres, ettersom de andre enten mangler begrepet eller definisjonen`,
reviewCards: `Gjennomgangskort`,
customizePractice: `Tilpasse praksis`,
next: `Neste`,
iWasRight: `jeg hadde rett`,
printProAlert: `Kjøp Pro -abonnement for å skrive ut mer enn 20 flashcards`,
print: `Skrive ut`,
printWidth: `Termin-def bredde`,
printFont: `Skriftstørrelse`,
printBorder: `Grense`,
printMargin: `Sidemargin`,
printPadding: `Ord polstring`,
preparingFile: `Utarbeide fil`,
notificationsBlocked: `Varsler er ikke aktivert, du aktiverer varsler fra telefonens innstillinger`,
ranOutOfWords: `Gikk tom for kort, start på nytt for å starte på nytt`,
ranOutOfWordsShort: `Gå tom for ord`,
ranOutOfWordsBody: `Åpne appen for å planlegge nye ord`,
proIncreaseNotifications: `Du kan øke de totale varslene fra 10 til 50 i premiumversjonen.`,
schedule: `Rute`,
frequency: `Frekvens`,
mode: `Modus`,
tM1: `1 minutt`,
tM2: `2 minutter`,
tM5: `5 minutter`,
tM10: `10 minutter`,
tM15: `15 minutter`,
tM30: `30 minutter`,
tH1: `1 time`,
tH2: `2 timer`,
termPassive: `Begrep passivt`,
termActive: `Begrep aktiv`,
defPassive: `Def passiv`,
defActive: `Def aktiv`,
scheduledIn: `Planlagt i __ minutter`,
scheduledAlertsProT: `Øk planleggbare varsler med Pro`,
scheduledAlertsProB: `Du kan øke de planlagte varslene fra 10 til 50 med Pro -pakken`,
seeFeatures: `Se funksjoner`,
defAndTerm: `Definisjon og begrep`,
termHoldDef: `Begrep, hold for å avsløre definisjon`,
defHoldTerm: `Definisjon, hold for å avsløre begrep`,
notificationType: `Varslingstype`,
copyToClipboard: `Kopiere til utklippstavle`,
enterAuthCode: `Vennligst skriv inn autorisasjonskoden din`,
invalidCode: `Ugyldig kode som er gitt`,
copied: `Kopiert!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Trykk for å oppdage alle premiumfunksjonene for å lære mer effektivt i ditt eget tempo`,
promoBtn: `Oppdag alle funksjoner`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Aktiver Dropbox Sync for å oppbevare settene, flashcards, tags og Progress Celped og oppdatert på alle enhetene dine.`,
setDropboxPOn: `Dataene dine er sikkerhetskopiert og synkronisert over enhetene dine.`,
setDropboxBtn: `Synkronisering`,
status: `Status`,
syncNow: `Synkroniser nå`,
contact: `Kontakt`,
contactUs: `Kontakt oss`,
useFromBrowser: `Bruk fra nettleseren`,
useFromBrowserMsg: `Besøk flashcardsmadesimple.com på datamaskinen din og gjenopprett kortene dine og lisensen ved å aktivere Dropbox Sync`,
termsPrivacy: `Vilkår og personvern`,
dailyReviewGoal: `Daglig gjennomgangsmål`,
numberTerms: `Antall vilkår`,
selectTerm: `Velg med semester hint`,
selectDef: `Velg med definisjon hint`,
pronounceTerm: `Uttale med semester hint`,
pronounceDef: `Uttal med definisjon hint`,
typeTerm: `Skriv med semester hint`,
typeDef: `Skriv med definisjon hint`,
quizTypes: `Foretrukne quiztyper`,
spacedRepetition: `Avstandsavsetningsplan`,
spacedRepetitionP: `REPEATTION TILDELER DEG MESTER ord med mindre innsats ved å trinnvis avstand ut gjennomgangstiden. Standardplanen er 1-3-7-15-31 dager, men du kan også sette opp en tilpasset.`,
spacedRepetionScheduleItem: `__ dager etter ___ gjennomgang (dag ____)`,
atLeastOneSchedule: `Det kreves minst en plan`,
revisionLimitReached: `Du nådde det maksimale revsisjonstallet`,
addReviewSchedule: `Legg til ny gjennomgangsplan`,
autoMarkLearnt: `Auto Mark lærte etter`,
autoMarkMastered: `Auto Mark mestret etter`,
tagManager: `Tag Manager`,
delete: `Slett`,
addTag: `Legg til ny tag`,
tagDeletionH: `Tag sletting`,
tagDeletionP: `Er du sikker på at du vil slette denne taggen?`,
cancel: `Avbryt`,
daysAfterLastReview: `Dager etter siste anmeldelse`,
linkDropbox: `Link Dropbox`,
startSync: `Start synkronisering`,
starred: `Med hovedrollen`,
images: `Bilder`,
tags: `Tagger`,
types: `Typer`,
activeDays: `Aktive dager`,
inactiveDays: `Inaktive dager`,
longestStreak: `Lengste strek`,
dailyGoalsCompleted: `Daglige mål fullført`,
dailyGoalsFailed: `Daglige mål mislyktes`,
typePairs: `Skriv par`,
reviewTypes: `Gjennomgå typer`,
typePractice: `Type praksis`,
pronouncePractice: `Uttale praksis`,
selectPractice: `Velg praksis`,
notificationReview: `Varslingsgjennomgang`,
flashcardReview: `Flashcard Review`,
studyset: `Studyset`,
enterStudysetName: `Vennligst skriv inn et navn for studysetten din`,
studysetName: `Enter Set's navn`,
termType: `TERM TYPE / LANG`,
defType: `Definisjonstype / lang`,
exportCards: `Eksportkort`,
importCards: `Importkort`,
quiz: `Quiz`,
showingOutOfCards: `Viser __ ut av ___ kort`,
showingAllCards: `Viser alle kortene, skriv inn ovennevnte søkefelt eller trykk på alle tagger for å filtrere`,
recording: `Innspilling`,
downloadSet: `Legg til settene mine`,
addNewCard: `Legg til nytt kort`,
saveStudyset: `Lagre studiesett`,
studysetDeletionH: `Studyset sletting`,
studysetDeletionP: `Er du sikker på at du vil slette denne studysetten, dette vil også slette alle inneholdte kort.`,
cardDeletionH: `Korts sletting`,
cardDeletionP: `Er du sikker på at du vil slette dette kortet`,
cardLimitReached: `Du kan bare ha 3000 kort i et studysett`,
limitExceeded: `Grensen overskredet`,
atLeastTenCards: `Legg til minst 10 kort for å komme i gang med praksis`,
searchInAll: `Søk i alle studiesett`,
noMatch: `Ingen treff`,
atLeastThreeChars: `Skriv inn minst 3 tegn for å søke`,
noSets: `Ingen sett`,
startingSync: `Startsynkronisering`,
noSetsP: `Velg fra alternativene nedenfor for å komme i gang`,
startingSyncP: `Vi får dataene dine fra Dropbox, dette kan ta en stund`,
createNewStudyset: `Lag ny studyset`,
restoreFromBackup: `Gjenopprett fra sikkerhetskopifilen`,
setStarterPacks: `Studyset starterpacks`,
selectPracticeType: `Velg øvingstype`,
noDueCards: `Ingen forfalte flashcards ennå, flashcards som du har gjennomgått før, vil begynne`,
noNewCards: `Ingen nye kort å studere`,
subscriptionH: `Kjøp Pro for å glede deg over alle funksjonene og for å støtte den kontinuerlige utviklingen.`,
buyLifetimePro: `Kjøp Lifetime Pro for __`,
restorePurchase: `GJENOPPRETT KJØP`,
termsPrivacyC: `Vilkår og personvernregler`,
licenceShare: `Hvis du kjøpte en lisens fra en annen enhet, kan du dele den med denne enheten ved å aktivere Dropbox -synkronisering på begge enhetene`,
enterTagName: `Skriv inn navnet på taggen`,
invalidName: `Ugyldig navn`,
create: `Skape`,
name: `Navn`,
tagName: `Navn på taggen din`,
color: `Farge`,
back: `Tilbake`,
rowSeparator: `Radeseparator`,
termDefSeparator: `Term - def separator`,
output: `Produksjon`,
inputCards: `Inngangskort`,
review: `Anmeldelse`,
language: `Språk`,
archiveReversible: `Arkiv (reversibelt fra innstillinger)`,
deletePermanent: `Slett (irreversibel)`,
archivedCards: `Arkiverte kort`,
masteredCards: `Mestret kort`,
due: `Forfaller`,
reviewed: `Anmeldt`,
markReviewed: `Mark vurderte`,
markMastered: `Mark mestret`,
forXYCards: `for __ ___ kort`,
createdAtSortBy: `Opprettelsesdato`,
lastReviewedSortBy: `Siste vurderingsdato`,
reviewCountSortBy: `Antall anmeldelser`,
strengthSortBy: `Styrke`,
termSortBy: `Alfabetisk begrep`,
definitionSortBy: `Alfabetisk def.`,
ascSortBy: `Stigende`,
descSortBy: `Synkende`,
featureSync: `Studer hva som helst, hvor som helst, når som helst med flashcards synkroniseres på alle enhetene dine`,
featureSpacedrepetition: `Se på din generelle fremgang, og kom tilbake til å øve på det du trenger å øve på`,
featureNotifications: `Supercharge Læringen din uten engang å åpne appen med fleksible varsler`,
featureFlashcards: `Autoplay flashcards når hendene eller øynene dine er opptatt, men du har fortsatt ubrukt oppmerksomhet`,
featureQuiz: `Match, stave ut, lytt eller velg å øve på flashcards`,
featureStats: `Få bedre innsikt i kortene og resultatene dine, og søk på tvers av alle flashcard -settene dine`,
featureImport: `Vi vil aldri lagre noen data om deg, og du kan eksportere og importere alle dataene dine enkelt`,
featurePrint: `Få litt læring ved å skrive ut flashcards, og DIY din egen studiestigning`,
splashIntro: `Studer alle flashcards hvor som helst i tempoet og stilen din`,
selectSortOrder: `Sorteringsrekkefølge`,
selectSortProp: `Sorter eiendom`,
applyFilters: `Bruk filtre`,
selectSetType: `Hva vil du øve?`,
getStarted: `Kom i gang`,
tapToUnarchive: `Trykk på kortene du vil unmarchive`,
untitled: `Uten navn`,
sortHintNew: `Du vil se kortene som ble opprettet for lengst siden først`,
sortHintDue: `Du vil se kort som har vært på grunn av det lengste først`,
sortHintOther: `Du vil se kort som ikke har blitt studert lengst først`,
flashcardsWhen: `, når hendene eller øynene dine er opptatt, selv mens du lytter til musikk / podcaster`,
notificationsWhen: `, for når du er ute og vil og bare vil ha raske studiebiter`,
quizWhen: `, for når du kan ta full oppmerksomhet for å studere, for å mestre kortene dine`,
features: `Egenskaper`,
ratings: `Rangeringer`,
notificationDailyCatchUpBody: `Nytt: __, forfaller: ___, Studerer: ____, lært: _____, mestret: ______`,
notificationDailyCatchUpTitle: `Daglig fangst`,
reviewedJN: `Gjennomgått akkurat nå`,
customUpdated: `Tilpasset tekst oppdatert`,
customTextField: `Synonymer, eksempler osv.`,
field: `Felt`,
link: `Lenke`,
backToParentCard: `Tilbake til overordnet kort`,
discard: `Kast`,
failedImageLoad: `Kunne ikke laste bilde, sørg for at du er koblet til Internett`,
printDIYLabel: `Diy ditt eget kreative papirbaserte studieoppsett, del med oss ​​din skapelse og bli omtalt i appen.`,
reviewGraphChart: `Gjennomgangsfrekvens`,
langNotSet: `Språk ikke satt`,
pronouncationLangInfo: `For å aktivere uttale må du velge begrepet og definisjonsspråket. Et høyttalertegn vises ved siden av språkene hvis enheten din støtter det språket`,
clearFilters: `Klart filter`,
subFreeUnlimited: `Ubegrensede studysetter, flashcards, praksis, søk og synkronisering`,
customFields: `Tilpassede felt`,
subLinks: `Kortlenker`,
subPrint: `Print / Studyset`,
subNotifications: `Varsling før du må åpne appen`,
subCardsStudysets: `Kort / studyset`,
subRevisionCycles: `Tilpassede revisjonssykluser`,
subscriptionHEnd: `Oppgradering til Pro viser oss at du synes det harde arbeidet vårt er verdifullt og gir oss oppmuntring og kaffe til å fortsette å forbedre og skape nye fantastiske ting.`,
subFree: `Gratis`,
subPro: `Pro`,
guideSpacedRepetition: `Hvordan fungerer avstandsrepetisjon og praksistyper`,
guideSearch: `Søke og filtrering`,
guideSync: `Aktiver sikkerhetskopiering og synkronisering på enhetene dine`,
guidePronunciation: `Aktiver uttaler`,
guideImport: `Importere kort fra å forlate kilder`,
guideAccess: `Hvem har tilgang til dataene mine?`,
guideData: `Hvilke data samler vi inn?`,
guideContact: `Trenger du hjelp med noe annet? Skriv til oss`,
arrowStrength: `Sett hvor godt du kjenner dette kortet`,
arrowImage: `Legg til bilder`,
arrowField: `Legg til flere tilpassede tekstfelt`,
arrowTag: `Fest tagger`,
arrowStar: `Mark som favoritt`,
arrowLink: `Lenke til andre kort`,
arrowGoal: `Sett opp et daglig gjennomgangsmål for deg selv`,
arrowDue: `Studer ord som skal gjennomgås`,
arrowNew: `Studiekort som ikke er gjennomgått ennå`,
arrowMastered: `Hvis du ikke har noen forfall eller nye kort, kan du gjennomgå mestret kort for å holde dem mestret`,
arrowImport: `Importer dine eksisterende flashcards`,
arrowNewCard: `Legg til nye flashcards`,
dropboxStep1: `1. Få tilgangskode fra Dropbox ved å logge inn`,
dropboxStep1Btn: `Logg inn med Dropbox`,
dropboxStep2: `2. Angi tilgangskode nedenfor`,
dropboxStep2Input: `Skriv kode her`,
dropboxStep3: `3. Start synkronisering`,
alreadyLinked: `Allerede koblet, trykk på for å fjerne`,
selectCardsToLink: `Velg kort for å lenke`,
unsupportedLangP: `Velg et språk som støtter uttalelse fra settets innstillinger`,
links: `Lenker`,
emailUs: `Send oss ​​en e -post`,
whatsappUs: `Whatsapp oss`,
printMinHeight: `Min. radhøyde`,
exportType: `Eksporter filtype`,
generateFileText: `Generere fil`,
generatatingFile: `Generere fil`,
verySmall: `Veldig liten`,
small: `Liten`,
normal: `Normal`,
big: `Stor`,
veryBig: `Veldig stor`,
repeatNTimes: `Gjenta __ ganger`,
pause: `Pause`,
for: `til`,
say: `Si`,
defShort: `Definert.`,
times: `ganger`,
autoplayPreferences: `Sett autoplay preferanser`,
autoPlay1: `Pause etter forrige ord`,
autoPlay2: `Antall semester uttalelser`,
autoPlay3: `Pause før du avslører definisjonen`,
autoPlay4: `Antall definisjonsuttalelser`,
autoPlay5: `Pause før du viser neste ord`,
autoPlay6: `Gjenta det samme flashcardet`,
startAutoPlay: `Start Autoplay`,
autoPlayOffConfirm: `Slå av autospiller for å aktivere manuelle kontroller`,
turnOff: `Skru av`,
keepPn: `Fortsett`,
foundIn: `Funnet i __`,
repeat: `gjenta`,
stop: `Stoppe`,
listenInBreak: `Visste du? Du kan høre på musikk / podcaster i pauser`,
contextSearch: `Kontekstsøk`,
contextSearchText: `Få eksempler på hvordan __ brukes i forskjellige setninger`,
transalteSearch: `Oversette`,
translateSearchText: `Oversett __ til ___`,
synonymSearch: `Synonymsøk`,
synonymSearchText: `Søk etter synonymer av __`,
selectToAdd: `Velg resultatene du vil legge til dette kortet`,
addToCard: `Legg til valgt til kort`,
hideFromPractice: `Gjemme deg i runde`,
setLanguageRequired: `Velg språket til begrepene og definisjonene i studysettdetaljene`,
fieldNeedsText: `Skriv inn noe i dette feltet før du søker`,
possibleDupe: `Mulig duplikat`,
loadNextXCards: `Last inn neste __ -kort`,
repeatPractice: `Gjenta disse __ -kortene`,
keepScreenOnInfo: `Det kan hende du må justere innstillingen for automatisk lås for å holde skjermen på mens du autoplaying.`,
siteLoginH2: `SFM -konto`,
siteLoginP: `Du kan bruke flashcards laget enkel konto for å dele flashcards med vennene dine, studentene dine eller hele samfunnet.`,
logOut: `Logg ut`,
logIn: `Logg Inn`,
createAccount: `Opprette ny konto`,
signUp: `Melde deg på`,
username: `Brukernavn`,
email: `E -post`,
password: `Passord`,
networkError: `Nettverksfeil`,
fillAllDetails: `Vennligst fyll ut alle detaljene`,
noUserWithDetails: `Ingen bruker som ble funnet med de angitte detaljene`,
userAlreadyExists: `Det gitte e -posten eller brukernavnet eksisterer allerede`,
signUpOrLoginToCont: `Registrer deg eller logg inn for å fortsette?`,
atLeastOneCardToShare: `Minst ett kort er pålagt å dele`,
publishingStudyset: `Publishing Studyset`,
updatesDetected: `Oppdateringer oppdaget, vil du fortsette å oppdatere lokale data? (Slettet: __, oppdatert: ___, nytt: ____)`,
updatesApplied: `Oppdateringer brukt`,
alreadyUpToDate: `Allerede oppdatert`,
practiceTypeArrow: `Oppdag forskjellige måter å prekitere på`,
share: `Dele`,
sharingModalIntro: `Del flashcardene dine i dette settet med vennene dine, studentene dine eller hele samfunnet.`,
whatIsShared: `Hva som deles`,
whatIsNotShared: `Det som ikke deles`,
whatIsSharedText: `Angi navn, angitt sikt språk, definisjonsspråk, alle inkluderte kort med vilkår, definisjoner, tilpassede tekstfelt og bilder`,
whatIsNotSharedText: `Eventuelle kortstyrker, stjerner, lenker, tagger og din gjennomgangshistorikk`,
checkForSharedUpdates: `Se etter oppdateringer fra Creator`,
fetchUpdates: `Hente oppdateringer`,
youSharedStudyset: `Du delte dette studiet`,
publishChanges: `Lagre og publiser endringer`,
redeem: `Innløse`,
noAds: `Ingen annonser`,
dupeDetection: `Duplikatdeteksjon`,
coffeeFeature: `Kaffe, for å hjelpe oss med å utvikle flere funksjoner`,
shareLink: `Dele lenke`,
coffeeForUs: `Du vil få livstidslisens for bare __, som gir Emily 6 -kaffe, Dominik 3 -kaffe og Russ 3 -kaffe, som vil gi oss i omtrent 39 timer for å gjøre dette apparrangementet bedre`,
sharingCards: `Deling av kort`,
published: `Publisert`,
alreadyHaveAccount: `Har du allerede en konto?`,
notAlreadyHaveAccount: `Har du ikke en konto ennå?`,
startPractice: `Start praksis`,
selectQuizTypes: `Velg quiztyper`,
correct: `Riktig`,
incorrect: `stemmer ikke`,
yes: `Ja`,
no: `Nei`,
levelSilver: `Sølvnivå __`,
levelGold: `Gullnivå __`,
levelPlatinum: `Platinumnivå __`,
levelDiamond: `Diamantnivå __`,
levelJade: `Jade nivå __`,
reviewsLeftGoal: `__ anmeldelser for det daglige målet`,
dailyGoalAchieved: `Daglig mål oppnådd`,
share: `Dele`,
rateApp: `Vurder app`,
allStats: `All statistikk`,
reviewTimeError: `Tidsavbrudd etter feil`,
reviewTimeCorrect: `Tidsavbrudd etter riktig`,
pronounceTermAfterReview: `Uttale begrep etter gjennomgang`,
pronounceDefinitionAfterReview: `Uttale definisjon etter gjennomgang`,
practice: `Øve på`,
notificationsScheduledInfo: `__ Varsler er planlagt, du kan lukke appen nå`,
wellDone: `Bra gjort`,
keepItUp: `Fortsett det`,
youRock: `Du rocker`,
niceOne: `Den var bra`,
lnSelect: `Velg språk`,
sampleData: `Ingen anmeldelser, som viser eksempeldata`,
reviewFreq: `Gjennomgangsfrekvens`,
selectPractice: `Øvelse: Velg`,
spellPractice: `Øvelse: Spell`,
connectPractice: `Øvelse: Koble til`,
languages: `Språk`,
languagesPairs: `Språkpar`,
shareArrow: `Del sett med venner, studenter eller hele samfunnet`,
cardsPerRound: `Kort / runde`,
showAll: `Vis alt`,
supportedLangsVary: `Støttede språk varierer`,
practiceWithoutSave: `Øv ikke lagret`,
practiceWithoutSaveBody: `Du har ikke lagt til dette studiet i samlingen din, vil du legge den til nå for å lagre studiens fremgang?`,
saveSetNow: `Lagre kort til deg Collection`,
continueWithoutSaveSave: `Start praksis uten lagring`,
createdBy: `Laget av`,
setSavedToYourCollection: `Studiesett lagret i samlingen din`,
accountBackupDisclaimer: `Vær oppmerksom på at denne kontoen bare kan brukes til å dele studysetter med andre, og ikke kan brukes til å sikkerhetskopiere eller synkronisere studysett eller flashcards. For å synkronisere og sikkerhetskopiere alle dataene dine, bruk Dropbox Sync`,
syncEnabled: `Synkronisering aktivert, hentet innholdet ditt pågår`,
searchAllSets: `Søkestudiesett fra andre brukere`,
anyLanguage: `Noe språk`,
trendingIn: `Trending inn`,
manualBackups: `Manuell sikkerhetskopi`,
manualBackupCreate: `Lag manuell sikkerhetskopi`,
confirmManualImport: `Er du sikker på at du vil erstatte alle gjeldende data med denne sikkerhetskopien? Dette anbefales bare på nye enheter uten data`,
importFromManualBackup: `Import fra sikkerhetskopi`,
imgOfflineSets: `Automatisk nedlasting av bilder for offline læring`,
unsupportedDeviceCache: `Denne funksjonen er bare tilgjengelig fra iOS- eller Android -appen`,
shareChanges: `Del __ Endringer`,
publiclySearchable: `Søkbar av brukere`,
description: `Beskrivelse`,
restoreFromDropboxBackup: `Gjenopprett fra Dropbox Backup`,
imageCacheStudysetSub: `[bare iOS & Android] Last ned bilde for offline studier`,
keywordsOrLangNeeded: `Du må legge inn noen nøkkelord, eller ett språk`,
dropboxAlreadyLinked: `Dropbox -konto er allerede koblet`,
noSetUpdateAccess: `Du har ikke tilgang til å redigere dette studiesettet.`,
confirmSetOwnerLogin: `Hvis du er sikker på at du er eieren, kan du prøve å logge deg på kontoen din igjen.`,
uninitedRestriction: `For å lagre fremgangen din, må du først legge denne studysetten til samlingen din`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Kunne ikke konsolidere lagring`,
consolidateStorageDone: `Lagringskonsolidering, vennligst la opp opptil en time for Dropbox å fullføre å fjerne gamle filer før du logger deg på en ny enhet.`,
consolidatingStorage: `Konsolidering av lagring ...`,
deleteAccount: `Slett konto`,
consolidateStorageDescription: `Denne operasjonen vil gjeninnføre sikkerhetskopieringsfilene dine, så det vil være raskere å sette opp nye enheter`,
consolidatingStorageConfirm: `Forsikre deg om at alle endringene dine allerede er ferdig med å synkronisere, ikke synkroniser andre enheter mens denne prosessen finner sted. Vil du fortsette?`,
consolidateStorage: `Konsolidere lagring`,


}